import withSSRModel from "hoc-lib/ssrModelMapper"
import { connect } from "react-redux"
import { userType } from "constants-lib/authentication"
import withRouter from "hoc-lib/router"
import { getServletErrorMessagesByServiceType } from "actions-lib/getServletErrorMessage/index"
import {
  getLiveChat,
  setCustomerLob,
  setGuidedFlowSelections,
  getContactBackAttributes,
  getServletFallbackMessage,
} from "actions-lib"
import { getGuestContainerRepairEligibility } from "actions-lib/getGuestContainerRepairEligibility"
import { fetchDataLocalsite } from "actions-lib/getLocalSitesCdn"
import { updateCurrentNeighborhood } from "actions-lib/updateCurrentNeighborhood"
import ExceptionMessageContainerModal from "./ExceptionMessageContainerModal"

export const mapDispatchToProps = {
  getLiveChat,
  getServletErrorMessagesByServiceType,
  fetchDataLocalsite,
  updateCurrentNeighborhood,
  getGuestContainerRepairEligibility,
  setCustomerLob,
  setGuidedFlowSelections,
  getContactBackAttributes,
  getServletFallbackMessage,
}

export const mapStateToProps = (state) => ({
  customerSelections: state.customerSelections,
  customerSupportContact: state.customerSupportContact,
  siteLanguage: state.siteLanguage,
  isLoggedIn: state.userAccount.userState === userType.LOGGED_IN,
  onlineProducts: state.onlineProducts,
  fallbackServletServices: state.fallbackServletServices,
})

const WrappedComponent = withSSRModel(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withRouter(ExceptionMessageContainerModal)),
)

export default WrappedComponent
